import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { CircularProgress, Box } from '@mui/material'

interface PrivateRouteProps {
  children: React.ReactNode
  requiredRoles?: string[]
  // ロール機能設定によるアクセス制御をスキップするかどうか
  // 基本機能（ダッシュボード、理解度テスト、プロフィール等）ではtrueを指定
  skipFeatureCheck?: boolean
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  requiredRoles = [],
  skipFeatureCheck = false,
}) => {
  const { isAuthenticated, isLoading, user, canAccessRoute } = useAuth()
  const location = useLocation()

  console.log('🛡️ PrivateRoute チェック:', {
    isAuthenticated,
    isLoading,
    userRole: user?.role,
    requiredRoles,
    currentPath: location.pathname,
    skipFeatureCheck,
    hasRequiredRole: requiredRoles.length === 0 || (user && requiredRoles.includes(user.role)),
  })

  // ローディング中は読み込み画面を表示
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    )
  }

  // 認証されていない場合はログイン画面にリダイレクト
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // 静的なロール権限チェック
  if (requiredRoles.length > 0 && user) {
    const hasRequiredRole = requiredRoles.includes(user.role)
    if (!hasRequiredRole) {
      return <Navigate to="/unauthorized" replace />
    }
  }

  // ロール機能設定によるアクセス制御（skipFeatureCheckがfalseの場合のみ）
  if (!skipFeatureCheck && user) {
    const hasFeatureAccess = canAccessRoute(location.pathname)
    if (!hasFeatureAccess) {
      console.log('🚫 ロール機能設定によりアクセス拒否:', location.pathname)
      return <Navigate to="/unauthorized" replace />
    }
  }

  return <>{children}</>
}
